import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { contactUsReason, defaultPage, sortingOptions } from "../../utils/constants";
import { isArray, parseCamelKey } from "../../utils/formatersAndParsers";
import { handleApiRequest } from "../../services/handleApiRequest";
import AskToShare from "../../Component/askToShare";
import MyPagination from "../../Component/common/pagination";
import ReactionsListsPop from "../../Component/Modals/reactionsListPop";
import { getQueriesList } from "../../redux/queries/thunk";
import QuerySkeleton from "../../Component/skeleton/querySkeleton";
import LoadIndicator from "../../Component/Loader";
import NoDataFound from "../../Component/common/noDataFound";
import SortingDropdown from "../../Component/common/filters/sortingDropdown";
import ContactReasonFilter from "../../Component/common/filters/contactReasonFilter";

export default function MyQueries() {
  const [searchParams] = useSearchParams();

  const { queriesList = {}, loadingQueryList = false } = useSelector(
    (state) => state.queries || {}
  );
  const [userAction, setUserAction] = useState(null);
  const [paginationDetails, setPaginationDetails] = useState({
    ...defaultPage,
    orderBy: sortingOptions[0].orderBy,
    order: sortingOptions[0].order,
  });

  const handleQueries = async () => {
    const reason = searchParams.get("reason") || "";

    const request = {
      ...paginationDetails,
      reason,
    };
    await handleApiRequest(getQueriesList, request);
  };

  useEffect(() => {
    handleQueries();
  }, [paginationDetails, searchParams]);

  return (
    <>
      <div className="w-100 overflow-auto">
        {queriesList.totalCount > 0 && (
          <div
            className={`${
              loadingQueryList ? "" : "hide-loader"
            } d-flex align-items-center justify-content-center`}>
            <LoadIndicator />
          </div>
        )}
        <div className="storyFilters d-flex align-items-center p-3 px-lg-5 gap-2">
          <SortingDropdown sortingOptions={sortingOptions.slice(1)} />
          <ContactReasonFilter sortingOptions={sortingOptions.slice(1)} />
        </div>

        <div className={`px-2 px-lg-3 pt-3`}>
          {loadingQueryList ? (
            Array.from({ length: 5 }).map((_) => <QuerySkeleton />)
          ) : isArray(queriesList.records).length > 0 ? (
            <>
              {isArray(queriesList.records).map((query, i) => (
                <div className="pointer position-relative shadow-sm mb-3 py-2 px-2 px-lg-3">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="m-0 truncate-1">
                      {contactUsReason.find((item) => item.value === query.reason)?.label}
                    </h5>
                    <p
                      className={`m-0 rounded-pill px-3 ${
                        query.status === "active"
                          ? "bg-warning text-dark"
                          : query.status === "closed"
                          ? "bg-danger text-white"
                          : "bg-success text-white"
                      } `}>
                      {parseCamelKey(query.status)}
                    </p>
                  </div>
                  <p>{query.comment}</p>
                </div>
              ))}
              <div className="d-flex justify-content-end py-3">
                <MyPagination
                  paginationDetails={paginationDetails}
                  setPaginationDetails={setPaginationDetails}
                  totalCount={queriesList.totalCount}
                  darkPagination={true}
                />
              </div>
            </>
          ) : (
            <NoDataFound />
          )}
        </div>

        <div className="curvatureContainer">
          <div>
            <div id="curved-corner-topright" />
          </div>
          <div>
            <div id="curved-corner-topleft" />
          </div>
        </div>

        <AskToShare />
      </div>
      {userAction?.action === "showReactionsList" && (
        <ReactionsListsPop userAction={userAction} setUserAction={setUserAction} />
      )}
    </>
  );
}
